export default __webpack_public_path__ + "static/media/pwd-vid.4977e67a.mp4";